// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  pageWrapper: {
    margin: '0 auto',
    width: '95%',
    marginTop: theme.spacing(6),
  },
  headerWrapper: {
    margin: 'auto',
    width: '95%',
  },
  headerOptions: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    columnGap: theme.spacing(2),
  },
  table: {
    width: '95%',
    margin: '0 auto',
  },
  iconTableCell: {
    borderBottom: 'none',
    textAlign: 'left',
    width: '30px',
    fontSize: '1em',
  },
  tableCell: {
    borderBottom: 'none',
    textAlign: 'left',
    'last-of-type': {
      color: 'blue',
      textAlign: 'right',
      width: '200px',
    },
    width: '300px',
    fontSize: '1em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '350px',
  },
  tableRow: {
    height: '80px',
  },
  projectOptions: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    columnGap: theme.spacing(3),
  },
  icons: {
    flexGrow: 0,
  },
  deleteIcon: {
    width: theme.spacing(5),
    '&:hover': {
      backgroundColor: '#fafafa !important',
    },
  },
  headerDivider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  itemsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  noOrderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '150px',
    gap: theme.spacing(3),
  },
  icon: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  routerLink: {
    color: theme.palette.primary.main,
  },
});

export default styles;
